// You can find the id here
// https://portal.sourcepoint.com/consent_v2/vendor_lists/edit?id=6233296a293cdf6b366969ee&non_iab=false
// Vendor: QUALAROO
const QUALAROO_ID: string = '6061aec5b5389c56c59ea325';
export default (grants: TSourcePointGrants): boolean => {
  return grants[QUALAROO_ID]?.vendorGrant;
};
